if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"plan","remotes":[{"alias":"notification","name":"notification","entry":"/notification/_next/static/chunks/remoteEntry.js","shareScope":"default"}],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return !/^((373|812|925)2|1995|4270|5016|7743|8594)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}